import axios from 'axios';
import { useAuthStore } from './store/auth.ts';

// API configuration
export const API_URL = process.env.REACT_APP_API_URL || 'https://m9qae45tzf.execute-api.eu-north-1.amazonaws.com/prod/';

// Configure axios instance
const axiosInstance = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
});

// Add request interceptor to handle authentication
axiosInstance.interceptors.request.use(
    (config) => {
        const { credential } = useAuthStore.getState();
        if (credential) {
            config.headers.Authorization = `Bearer ${credential}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor to handle authentication errors
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Handle unauthorized access
            useAuthStore.getState().logout();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
